import { RefObject } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import { notify } from './notification'

export default async function handleRecaptcha(
  recaptchaRef: RefObject<ReCAPTCHA | null>,
): Promise<boolean> {
  const token = await recaptchaRef.current?.getValue()
  if (!token) {
    notify('Por favor, complete o reCAPTCHA.', 'warning')
    return false
  }
  const response = await fetch('/api/verify-recaptcha', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ token }),
  })
  const data = await response.json()

  if (data.success) {
    return true
  } else {
    notify('Falha na validação do reCAPTCHA.', 'error')
    return false
  }
}
